module.exports = __webpack_public_path__ + "img/CurrentTime-icon.5dcee99c.svg";